import { OriginData, WEB3AUTH_NETWORK_TYPE, type WhiteLabelData } from "@web3auth/auth";
import base64url from "base64url";
import recursiveJSONParse from "json-stable-parse";

import config from "@/config";
import { jsonToHash, queryToJson } from "@/utils/helpers";
import { WhiteLabelParams } from "@/utils/interfaces";
import { getWhitelist, isAllowedHosts, validateRedirect } from "@/utils/validateRedirect";

export default class PasswordlessHandler {
  readonly authBaseApiUrl = `${config.authServerUrl}/api/v3/auth`;

  passwordlessParams: Record<string, string>;

  trackingIdentifier?: string;

  constructor(currentHref: string) {
    this.passwordlessParams = queryToJson(currentHref);
  }

  get state(): Record<string, string> {
    return JSON.parse(base64url.decode(decodeURIComponent(this.passwordlessParams.state || "")) || "{}");
  }

  get connectorClientId(): string {
    return this.passwordlessParams.client_id as string;
  }

  get web3authClientId() {
    return this.state.client;
  }

  get whiteLabelParams(): WhiteLabelParams {
    const { whiteLabel } = this.state;
    if (!whiteLabel) return {};

    const { appName, appUrl, defaultLanguage, mode, logoLight, logoDark, theme } = recursiveJSONParse(whiteLabel) as WhiteLabelData;
    const finalLogo = (mode === "dark" ? logoDark : logoLight) ?? "";
    return {
      mode: mode ?? "light",
      name: appName ?? "",
      url: appUrl ?? "",
      language: defaultLanguage ?? "en",
      logo: finalLogo.includes(".svg") ? "" : finalLogo,
      theme: theme ?? {},
    };
  }

  get trackingId(): string | undefined {
    return this.trackingIdentifier;
  }

  set trackingId(value: string | undefined) {
    this.trackingIdentifier = value;
  }

  redirectToClient(jsonData: Record<string, string>): void {
    const redirectUri = this.passwordlessParams.redirect_uri as string;
    const redirectionUrl = jsonToHash(redirectUri, jsonData);
    window.location.href = redirectionUrl;
  }

  async validteRedirectUri(): Promise<boolean> {
    const redirectUri = this.passwordlessParams.redirect_uri as string;
    let originData: OriginData = {};
    if (!isAllowedHosts(redirectUri)) {
      originData = await getWhitelist(this.web3authClientId, this.passwordlessParams.network as WEB3AUTH_NETWORK_TYPE);
    }

    await validateRedirect(this.web3authClientId, new URL(redirectUri).origin, originData);
    return true;
  }
}
